import { tips } from "@/mocks/home";

export default function ViewingGuide() {
  return (
    <section id="guide" className="border-b border-background-200/70 bg-background-100/60">
      <div className="flex flex-col gap-10 px-4 py-12 md:px-10 md:py-16 lg:flex-row lg:gap-14">
        <div className="w-full lg:w-1/3">
          <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-secondary-600">
            <i className="ri-compass-3-line text-base"></i>
            VIEWING GUIDE
          </div>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            观影小贴士
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            第一次来？先看看这几个常见问题，能帮你更快找到想看的那个版本。
          </p>
          <div className="mt-6 rounded-lg border border-background-200/80 bg-background-50 p-5">
            <div className="text-xs text-foreground-500">版本速查</div>
            <div className="mt-3 space-y-2.5 text-sm text-foreground-800">
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-primary-500"></span>
                完整版 · 时长 100 分钟以上
              </div>
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-accent-500"></span>
                短片 · 10 分钟左右
              </div>
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-secondary-500"></span>
                字幕版 · 标注翻译类型
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-2/3">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {tips.map((tip) => (
              <article
                key={tip.id}
                className="rounded-lg border border-background-200/80 bg-background-50 p-5"
              >
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  <a href="#guide" className="transition-colors hover:text-primary-600">
                    {tip.title}
                  </a>
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{tip.body}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}